import branchAndServicePoint from 'locales/dental/th/setting/branch-service-point.json'
import defaultLab from 'locales/dental/th/setting/default-labs.json'
import defaultProduct from 'locales/dental/th/setting/default-products.json'
import defaultUsers from 'locales/dental/th/setting/default-users.json'
import defaultSetting from 'locales/dental/th/setting/defaults.json'
import dfManagement from 'locales/dental/th/setting/doctor-fee-managements.json'
import cfManagement from 'locales/dental/th/setting/credit-fee-managements.json'
import finance from 'locales/dental/th/setting/finances.json'
import personalManagement from 'locales/dental/th/setting/personnel-managements.json'
import treatmentCourse from 'locales/dental/th/setting/treatment-courses.json'
import treatmentPlan from 'locales/dental/th/setting/treatment-plans.json'
import treatmentRight from 'locales/dental/th/setting/treatment-rights.json'
import treatment from 'locales/dental/th/setting/treatments.json'
import doctorNote from 'locales/dental/th/setting/doctor-note.json'
import formatForm from 'locales/dental/th/setting/branch-format-form.json'
import breakManagement from 'locales/dental/th/setting/break-management.json'

export const Setting = {
  ...branchAndServicePoint,
  ...defaultLab,
  ...defaultProduct,
  ...defaultUsers,
  ...defaultUsers,
  ...defaultSetting,
  ...dfManagement,
  ...finance,
  ...personalManagement,
  ...treatmentCourse,
  ...treatmentPlan,
  ...treatmentRight,
  ...treatment,
  ...doctorNote,
  ...cfManagement,
  ...formatForm,
  ...breakManagement
}
